<template>
  <div class="content">      
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8 col-sm-8 col-md-offset-2 col-sm-offset-2">
          <!-- <div class="card"> -->
            <!-- <div class="card-content"> -->
              <div class="row">
                <div class="col-md-3 col-md-offset-5">
                <img id="login-img" src="../../../static/img/logo.png"
                    class="rounded mx-auto d-block"
                    alt="LoJack Logo">
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-md-5 col-md-offset-4">
                  <fg-input type="text"
                            label="Username"
                            v-model="username">
                  </fg-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5 col-md-offset-4">
                  <fg-input type="password"
                            label="Clave"
                            v-model="password">
                  </fg-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-5 col-md-offset-4">
                  <span class="form-group__message" v-if="error_message">{{ error_message }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2 col-md-offset-4">
                  <button type="button"  @click="authenticate()" class="btn btn-sm btn-primary">Iniciar Sesión</button>
                </div>
              </div>

            <!-- </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
  * Services
  */
import auth from '../../authService.js'
import config from '../../config.js'

export default {
  data () {
    return {
      username: config.defaultUsername(),
      password: config.defaultPassword(),
      error_message: null
    }
  },
  methods: {
    authenticate () {
      auth.login(this.username, this.password).then(
        responseOk => { this.$router.push('/admin/main') },
        responseError => { this.handle_error(responseError) })
    },
    handle_error (responseError) {
      console.log('Error ' + JSON.stringify(responseError))
      this.error_message = 'Error inesperado, contacte al administrador'
      if (responseError.body.code === 'invalid_client') {
        this.error_message = 'Usuario/Clave Inválidos'
      }
    }
  }
}
</script>
<style>

.form-group__message {
  border-color: red;
  background: #FDD;
}

#login-img {
  height: 150px;
  width: 150px;
  background-color:darkgray;
}

</style>



// WEBPACK FOOTER //
// Login.vue?0bf9f224